import * as tslib_1 from "tslib";
// Actions
import { AuthActionTypes } from '../_actions/auth.actions';
export var initialAuthState = {
    loggedIn: false,
    authToken: undefined,
    user: undefined,
    role_id: undefined,
    user_id: undefined,
    isUserLoaded: false
};
export function authReducer(state, action) {
    if (state === void 0) { state = initialAuthState; }
    switch (action.type) {
        case AuthActionTypes.Login: {
            var _token = action.payload.authToken;
            var _role_id = action.payload.role_id;
            var _user_id = action.payload.user_id;
            return {
                loggedIn: true,
                authToken: _token,
                user: undefined,
                role_id: _role_id,
                user_id: _user_id,
                isUserLoaded: false
            };
        }
        case AuthActionTypes.Register: {
            var _token = action.payload.authToken;
            var _role_id = action.payload.role_id;
            var _user_id = action.payload.user_id;
            return {
                loggedIn: true,
                authToken: _token,
                user: undefined,
                role_id: _role_id,
                user_id: _user_id,
                isUserLoaded: false
            };
        }
        case AuthActionTypes.Logout:
            return initialAuthState;
        case AuthActionTypes.UserLoaded: {
            var _user = action.payload.user;
            return tslib_1.__assign({}, state, { user: _user, isUserLoaded: true });
        }
        default:
            return state;
    }
}
